module.exports = __webpack_public_path__ + "img/2020_11_07_floaty_tendrils.5ec7ad58.jpg";